import { fetchBuildersProjectsData } from '../../services/fetchBuildersProjectsData';
import { TThunkAction } from '../../types/redux';
import { smoothScrollToPositionAsync } from '../../utils/scroll';
import { setBuildersProjectsData, startFetching } from '../buildersProjects';
import { DEFAULT_LIMIT, DEFAULT_PAGE } from '../../constants/pagination';
import { IFilters } from '../../types/filters';
import { updateUrl } from '../../utils/url';
import { trackPageView } from '../../utils/analytics';

interface IParams {
  filters?: IFilters;
  page?: number;
  limit?: number;
  shouldUpdateUrl?: boolean;
}

export const fetchBuildersProjects = ({
  filters,
  page = DEFAULT_PAGE,
  limit = DEFAULT_LIMIT,
  shouldUpdateUrl = true,
}: IParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    dispatch(startFetching());

    const { buildersProjects } = getState();

    const [data] = await Promise.all([
      fetchBuildersProjectsData(context, {
        ...filters,
        page,
        limit,
        regionId: buildersProjects.data.location?.id,
      }),
      smoothScrollToPositionAsync(0),
    ]);

    dispatch(setBuildersProjectsData(data));

    if (shouldUpdateUrl) {
      updateUrl({ filters, page });
    }

    if (data.page !== buildersProjects.data.page) {
      const { deviceType, userId } = context.custom;

      trackPageView({ buildersProjects: data, deviceType, userId });
    }
  };
};
